// #552 — the one prompt for a guest who taps an action that needs an
// account: the bout bell (#515) and Register Boxers (#263). The prompt offers
// the sign-in and a guide of the manual. Before #552 each place had its own
// copy, with the main action last and no Cancel.
import { useNavigate } from 'react-router-dom';
import ModalBackdrop from './ModalBackdrop';
import ModalHeader from './ModalHeader';
import ModalFooter from './ModalFooter';
import { useI18n } from '../../i18n';

interface GuestPromptProps {
  /** The title, and the name of the dialog (pinned by e2e: keep it exact). */
  title: string;
  text: string;
  /** The section of the manual, for example '/manual#coach'. */
  guideHref: string;
  guideLabel: string;
  onClose: () => void;
}

export default function GuestPrompt({ title, text, guideHref, guideLabel, onClose }: GuestPromptProps) {
  const { t } = useI18n();
  const navigate = useNavigate();
  return (
    <ModalBackdrop onClose={onClose} maxWidth="sm" ariaLabel={title}>
      <ModalHeader title={title} />
      <p className="text-sm text-gray-600">{text}</p>
      <ModalFooter
        secondary={(
          <button type="button" className="btn-outline btn-sm" onClick={() => navigate(guideHref)}>
            {guideLabel}
          </button>
        )}
        onSave={() => navigate('/login')}
        saveLabel={t.nav.login}
        onCancel={onClose}
      />
    </ModalBackdrop>
  );
}
